export const Digital = 'D';
export const Paper = 'L';
export const NoDeclaration = 'N';
export const Undecided = 'X';

export function isDecided(stav) {
    return stav === Digital
        || stav === Paper
        || stav === NoDeclaration;
}
